const STORAGE_KEY = "prediction-market-portal.participant";

/**
 * @typedef {{
 *   participant_id: string,
 *   memo: string,
 *   status: 'pending' | 'verified' | string,
 *   moonlight_account?: string | null,
 *   trading_commitment_hex?: string | null,
 *   proof_tx_hash?: string | null,
 *   created_at?: string,
 *   verified_at?: string | null,
 *   commitment_linked_at?: string | null,
 * }} ParticipantRecord
 */

/** @returns {ParticipantRecord | null} */
export function loadParticipant() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** @param {ParticipantRecord} record */
export function saveParticipant(record) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
}

export function clearParticipant() {
  localStorage.removeItem(STORAGE_KEY);
}

export function isParticipantReady(record = loadParticipant()) {
  return Boolean(
    record?.status === "verified" &&
      record?.trading_commitment_hex &&
      record.trading_commitment_hex.length === 64
  );
}
